function getContractRouteId(contractLike) {
  if (!contractLike) {
    return null;
  }

  return contractLike.policyId || contractLike.id || null;
}

export {
  getContractRouteId,
};
